module.exports = __webpack_public_path__ + "static/media/07-Model-12.246dd1e9.webp";